export default __webpack_public_path__ + "static/media/rocket.2df4cc51.svg";